module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/polityka-rachunkowosci.json
// module id = 547
// module chunks = 82953272724940